export const Switch = {
  defaultProps: {
    colorScheme: "brandFull",
  },
};
